module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/5_1f21330937092d2e6c28b59acb3e5c77.png";